import {
  Accordion,
  AccordionContent,
  AccordionItem,
} from "@/components/reusables/ui/accordion"
import { useEffect, useState } from "react"
import {
  PRE_QUAL_QUESTIONS,
  type QuestionValues,
} from "@/screens/prequal/questions"
import { preQualStepViewed } from "@/analytics/events/preQual"
import { RadioButtonQuestion } from "@/screens/prequal/components/RadioButtonQuestion"
import { updatePreQual, usePreQualState } from "@/stores/preQual"
import { PreQualTrigger } from "@/screens/prequal/components/PreQualTrigger"
import { IntentStatusQuestion } from "@/screens/prequal/components/IntentStatusQuestion"

export const MultiQuestionScreen = ({
  questions,
  className,
  activeChanged,
}: {
  className?: string
  questions?: QuestionValues[]
  activeChanged?: (active: QuestionValues) => void
}) => {
  const askedQuestions: QuestionValues[] =
    questions || PRE_QUAL_QUESTIONS.map((q) => q.questionValue)

  const [active, setActive] = useState<undefined | QuestionValues>(undefined)
  const preQualState = usePreQualState()

  useEffect(() => {
    if (active) {
      preQualStepViewed(
        PRE_QUAL_QUESTIONS.find((q) => q.questionValue === active)!
          .viewAppScreen
      )
      activeChanged?.(active)
    }
  }, [active])

  useEffect(() => {
    if (!active) {
      // Find the first question that hasn't been answered
      const firstUnanswered = askedQuestions.find((q) => !preQualState[q])!
      setActive(firstUnanswered)
    }
  }, [preQualState, active])

  return (
    <Accordion
      type="single"
      collapsible
      defaultValue={active}
      value={active}
      className={`w-full ${className}`}
      onValueChange={(value) => {
        setActive(value as QuestionValues)
      }}
    >
      {askedQuestions.map((key) => {
        const question = PRE_QUAL_QUESTIONS.find(
          (q) => q.questionValue === key
        )!
        const Component =
          question?.questionType === "intentStatus"
            ? IntentStatusQuestion
            : RadioButtonQuestion

        return (
          <AccordionItem key={key} value={key}>
            <PreQualTrigger
              question={question}
              value={preQualState[key] as string}
            />
            <AccordionContent>
              <Component
                onValueChange={(val) => {
                  setActive(undefined)
                  updatePreQual(key, val)
                }}
                question={question}
              />
            </AccordionContent>
          </AccordionItem>
        )
      })}
    </Accordion>
  )
}
